import React from 'react';
import './main-view.scss';
// Import only the waitlist component since this branch is waitlist-only
import { WaitingList } from '../../splash-page/waiting-list';
import { Box } from '@chakra-ui/react';

export const MainView: React.FC = () => {
  return (
    <Box>
      <WaitingList />
    </Box>
  );
};
